import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import DashboardLayout from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/settings/settingsAgency'));
const ServiceType = lazy(() => import('src/pages/settings/settingsServiceType'));
const PackageType = lazy(() => import('src/pages/settings/settingsPackageType'));
const DeliveryType = lazy(() => import('src/pages/settings/settingsDeliveryType'));
const RemittanceDeliveryType = lazy(
  () => import('src/pages/settings/settingsRemittanceDeliveryType')
);
const RemittancePickupLocation = lazy(
  () => import('src/pages/settings/settingsRemittancePickupLocation')
);
const ContentType = lazy(() => import('src/pages/settings/settingsContentType'));
const ContentTypeRange = lazy(() => import('src/pages/settings/settingsContentTypeRange'));
const ContentCategory = lazy(() => import('src/pages/settings/settingsContentCategory'));
const ProductsList = lazy(() => import('src/pages/settings/settingsProductsList'));
const ProductsCreate = lazy(() => import('src/pages/settings/settingsProductsCreate'));
const ProductsEdit = lazy(() => import('src/pages/settings/settingsProductsEdit'));
const PickupLocation = lazy(() => import('src/pages/settings/settingsPickupLocation'));
const Provincia = lazy(() => import('src/pages/settings/settingsProvincia'));
const Municipio = lazy(() => import('src/pages/settings/settingsMunicipio'));
const Payment = lazy(() => import('src/pages/settings/settingsPayment'));
const PassportServicesType = lazy(() => import('src/pages/settings/settingsPassportServiceType'));
const MigrationForms = lazy(() => import('src/pages/settings/settingsMigrationForms'));

export const settingsRoutes = [
  {
    path: 'agency',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <IndexPage />, index: true },
      { path: 'services-type', element: <ServiceType /> },
      { path: 'packages-type', element: <PackageType /> },
      { path: 'delivery-type', element: <DeliveryType /> },
      { path: 'remittance-delivery-type', element: <RemittanceDeliveryType /> },
      { path: 'remittance-pickup-location', element: <RemittancePickupLocation /> },
      { path: 'content-type', element: <ContentType /> },
      { path: 'content-type-range', element: <ContentTypeRange /> },
      { path: 'content-category', element: <ContentCategory /> },
      { path: 'products', element: <ProductsList /> },
      { path: 'products/new', element: <ProductsCreate /> },
      { path: 'products/:id/edit', element: <ProductsEdit /> },
      { path: 'pickup-location', element: <PickupLocation /> },
      { path: 'provincia', element: <Provincia /> },
      { path: 'municipio', element: <Municipio /> },
      { path: 'payment', element: <Payment /> },
      { path: 'passport-category-type', element: <PassportServicesType /> },
      { path: 'migration-forms', element: <MigrationForms /> },
    ],
  },
];
